import Dropdown from 'blocks.simple/dropdown/dropdown'
import { ENCODING, ENCODING_OPTIONS } from '../constant'
import translate from 'core/translate'
import React from 'react'

type Props = {
    handleSelectEncoding: (selectedEncoding: { id: ENCODING; name: string }) => void
    showEncoding: boolean
    encoding: ENCODING
}

const EncodingDropdown = ({ handleSelectEncoding, showEncoding, encoding }: Props) => {
    if (!showEncoding) return null
    return (
        <Dropdown
            label={translate('encoding')}
            indentSize={'normal'}
            onChange={(selected) => {
                handleSelectEncoding(selected)
            }}
            options={ENCODING_OPTIONS}
            value={encoding}
        />
    )
}

export default EncodingDropdown
